import { Box, Typography } from '@mui/material'
import React from 'react'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import ValidationErrorText from './ValidationErrorText';

export default function FormPhoneInputField({ label = "",countryCode, value, placeholder = "",disableDropdown=false, onChange, fieldErros, fieldError, onBlur = () => { }, disabled = false }) {
    return (
        <Box sx={{ marginBottom: { xl: '10px', lg: '10px', md: '10px', xs: '0px' } }}>
            <Typography sx={{ fontSize: { xl: '13px', lg: '13px', md: '13px', md: '13px', xs: '12px' }, fontWeight: '500', color: '#020202', marginBottom: '5px' }}>
                {label}
            </Typography>
            <PhoneInput
                country={countryCode || 'in'}
                value={value || ""}
                countryCodeEditable={false}
                disableDropdown={disableDropdown}
                onBlur={onBlur}
                onChange={(value) => { !disabled && onChange(value)}}
                specialLabel=""
                inputStyle={{
                    width: '100%', height: '35px',
                    // padding: '8px 14px',
                    boxSizing: 'border-box',
                    fontSize: '12px',
                }}
                placeholder={placeholder || "Enter mobile number"}
                inputProps={{ name: 'phone' }}
            />

            <ValidationErrorText error={fieldError} />
        </Box>
    )
}
